<template>
  <div>
    <b-modal
      id="rating-modal"
      v-model="show"
      hide-header centered hide-footer
      no-close-on-esc no-close-on-backdrop
    >
    <div v-if="conclusion" class="text-center my-2">
        <feather-icon
          icon="CheckCircleIcon"
          class="text-success"
          size="80"
        />
        <h3 class="mt-1 font-weight-bolder">Obrigado!</h3>
        <h5 class="mt-2">
            Agradecemos seu feedback.
        </h5>
        <b-button class="mt-2" variant="custom-blue" @click="hideModal()">
            Concluído
        </b-button>
    </div>
    <div v-else>
        <div class="d-flex justify-content-between align-items-center mt-1">
          <h3 class="m-0 font-weight-bolder">Avalie sua experiência</h3>
          <feather-icon icon="XIcon" size="20" class="cursor-pointer" @click="saveRating(true)" />
        </div>
        <h5 class="mt-2">
          Qual é o seu nível de satisfação com sua experiência de adesão?*
        </h5>
        <CustomRatingStars
            @finalRating="(val) => { rating =  val}"
        />
        <h5 class="mt-2">
        Explique com mais detalhes
        </h5>
        <b-form-textarea
            id="rating-textarea"
            v-model="commentary"
            placeholder="Deixe seu comentário (opcional)"
            rows="6"
            :state="invalidCommentary ? false : null"
        />
        <small v-if="invalidCommentary" class="text-danger">O número máximo de 1000 caracteres foi excedido.</small>
        <div class="my-2 d-flex">
            <b-button :disabled="!rating || invalidCommentary" variant="custom-blue" class="mr-1" @click="saveRating()">
                Enviar
            </b-button>
            <b-button variant="outline-custom-blue" @click="saveRating(true)">
                Cancelar
            </b-button>
        </div>
    </div>
    </b-modal>
  </div>
</template>

<script>
import { BModal, BFormTextarea, BButton } from 'bootstrap-vue'
import CustomRatingStars from './CustomRatingStars.vue';

export default {
    components: {
        BModal,
        BFormTextarea,
        BButton,
        CustomRatingStars
    },
    props: {
        modalShow: {
            required: true,
            type: Boolean
        },
        originRating: {
            required: true,
            type: String
        },
        additionalParams: {
            required: false,
            type: Object
        }
    },
  data: () => ({
    show: false,
    rating: null,
    conclusion: false,
    commentary: ''
  }),
  mounted() {
    this.show = this.modalShow
  },
  computed: {
    invalidCommentary() {
      return this.commentary.length > 1000
    }
  },
  methods: {
    async saveRating(ignoreModal = false) {
       await this.$http.post(this.$api.avaliacao(), {
          ...this.additionalParams,
          nota: !ignoreModal ? this.rating.nota : null,
          comentario: !ignoreModal ? this.commentary : null,
          origem: this.originRating
       }).then(() => {
          if(ignoreModal){
              this.hideModal()
          }else{
            this.show = false
            setTimeout(() => {
                this.show = true
                this.conclusion = true;
            }, 150)
          }
       })
    },
    hideModal() {
      this.show = false;
      this.$emit('hideModal');
    },
  },
  watch: {
    modalShow(val) {
      this.show = val;
    }
  }
}
</script>
